import React, {useCallback, useState} from 'react';
import {useCategory} from '../../../../../data/hooks/categories';
import FieldSelection from './FieldSelection/FieldSelection';
import { first } from 'lodash';

function AddField(props) {
    const {condition, onAddSubCondition} = props,
        category = useCategory(condition.category),
        [showAddField, setShowAddField] = useState(false);

    const handleNewFieldSelected = useCallback(
            field => {
                setShowAddField(false);
                onAddSubCondition({
                    field: field.name,
                    operator: first(field.operators).id,
                });
            },
            [onAddSubCondition]
        ),
        handleAddField = useCallback(() => setShowAddField(true), []);

    if (showAddField || !condition.OR.length) {
        return <FieldSelection className="my-3" fields={category.fields} onSelect={handleNewFieldSelected} />;
    }

    return (
        <div className="row my-3">
            <div className="col-sm-12">
                <button type="button" className="btn-link" onClick={handleAddField}>
                    + Extend group...
            </button>
            </div>
        </div>
    );
}

export default AddField;
